import { BaseService } from './../base'

export class DocumentTypeService extends BaseService {
  static get entity () {
    return 'document_type'
  }
  static get name () {
    return 'document_type'
  }
}